/* Postal code to delivery days, on the homepage.
   Same rule shape as the cart: a zone owns a list of 2 digit postal districts. The rules
   come from the section's own blocks, so the answer here and the list beside it are the
   same data. No network call, nothing to go stale. */
(function () {
  function init() {
    var root = document.getElementById('dx-zonecheck');
    if (!root || root.dataset.dxReady) return;
    root.dataset.dxReady = '1';

    var input = document.getElementById('dx-zc-input');
    var go = document.getElementById('dx-zc-go');
    var out = document.getElementById('dx-zc-out');
    if (!input || !go || !out) return;

    var rules = [];
    try { rules = JSON.parse(root.dataset.zoneRules || '[]'); } catch (e) { rules = []; }
    var cards = root.querySelectorAll('.dx-zcard');
    var hint = out.textContent;
    var lastSent = '';

    function zoneFor(postal) {
      var district = postal.slice(0, 2);
      for (var i = 0; i < rules.length; i++) {
        if ((rules[i].districts || []).indexOf(district) !== -1) return rules[i];
      }
      return null;
    }

    function highlight(id) {
      cards.forEach(function (c) { c.classList.toggle('is-on', !!id && c.dataset.zoneId === id); });
    }

    function track(postal, zone) {
      // one GA4 event per distinct postal code, and never the code itself
      if (postal === lastSent) return;
      lastSent = postal;
      if (typeof window.dxTrack === 'function') window.dxTrack('delivery_zone_check', { zone: zone || 'unmatched' });
    }

    function check() {
      var postal = (input.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = postal;

      if (postal.length < 6) {
        out.textContent = postal.length ? 'That is ' + postal.length + ' of 6 digits.' : hint;
        out.className = 'dx-zcheck-out';
        highlight(null);
        return;
      }

      var rule = zoneFor(postal);
      if (!rule) {
        out.textContent = 'We do not have that postal code on a route yet. WhatsApp us and we will tell you straight away.';
        out.className = 'dx-zcheck-out dx-zcheck-out--warn';
        highlight(null);
        track(postal, null);
        return;
      }

      out.innerHTML = '';
      var area = document.createElement('b');
      area.textContent = rule.zone;
      out.appendChild(document.createTextNode('You are in '));
      out.appendChild(area);
      out.appendChild(document.createTextNode('. We deliver '));
      var days = document.createElement('b');
      days.textContent = rule.days;
      out.appendChild(days);
      out.appendChild(document.createTextNode(rule.note ? '. ' + rule.note : '.'));
      out.className = 'dx-zcheck-out dx-zcheck-out--hit';
      highlight(rule.id);
      track(postal, rule.zone);
    }

    go.addEventListener('click', check);
    input.addEventListener('input', check);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
